import { en, ru } from "./i18n/catalogs.js"

const catalogs = { ru, en }

/**
 * @param {string} key
 * @param {{ locale?: string, defaultValue?: string, [k: string]: unknown }} [opts]
 */
export function t(key, opts = {}) {
  if (!key) return opts.defaultValue ?? ""
  const locale = (opts.locale || "ru").toString().split("-")[0]
  const catalog = catalogs[locale] || catalogs.ru
  let text = catalog[key]
  if (text == null && locale !== "en") text = catalogs.en[key]
  if (text == null) text = opts.defaultValue ?? ""
  if (!text) return ""
  return String(text).replace(/%\{(\w+)\}/g, (_, name) => {
    const v = opts[name]
    return v == null ? "" : String(v)
  })
}

export function titleForKey(key, locale = "ru") {
  const resolved = t(key, { locale })
  if (resolved) return resolved
  if (!key) return ""
  const parts = String(key).split(".")
  return parts[parts.length - 1] || key
}

export { catalogs }
